import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const laneRatesAdapter = getAdapter();

const laneRatesSlice = createSlice({
  name: 'laneRates',
  initialState: laneRatesAdapter.getInitialState(),
  reducers: {
    setLaneRates: (state, { payload: { laneRates } }) => {
      laneRatesAdapter.setAll(state, laneRates);
    },
  },
});

const selectors = laneRatesAdapter.getSelectors(({ laneRates }) => laneRates);

export const getLaneRates = (state) => selectors.selectAll(state);

export const {
  setLaneRates,
} = laneRatesSlice.actions;

export default laneRatesSlice.reducer;
